var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M8.873 9.965l.51 1.072 1.162-.262-.518 1.065.93.742-1.162.263v1.192l-.922-.75-.93.75v-1.192l-1.163-.263.938-.742-.518-1.065 1.155.262.518-1.072zm9.27 1.335l.247.51.555-.128-.247.51.442.353-.555.127v.57l-.443-.36-.442.36v-.57l-.555-.127.45-.353-.247-.51.547.128.247-.51zm-2.28-5.438l.247.518.555-.135-.247.517.442.353-.555.12v.57l-.442-.353-.443.353.008-.57-.556-.12.443-.353-.247-.517.555.135.24-.518zm2.28-3.105l.247.518.555-.128-.247.51.442.353-.555.12v.57l-.443-.353-.442.353v-.57l-.555-.12.45-.353-.247-.51.547.128.247-.518zm1.994 2.333l.24.51.556-.128-.248.51.443.353-.555.127.007.57-.442-.36-.443.36v-.57l-.555-.127.442-.353-.247-.51.555.128.247-.51zm-1.425 2.715l.188.592h.63l-.51.368.195.592-.503-.367-.51.367.195-.592-.502-.368h.622l.195-.592zM12-.003V1.43L9.885 2.607H12V5.39H9.232L12 6.927V8h-1.252L7.305 6.087V8h-2.61V5.72L.6 8H0V6.567L2.115 5.39H0V2.607h2.768L0 1.07V-.003h1.252L4.696 1.91V-.003h2.61v2.28L11.4-.003h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.75-.003h-1.5v3.255H0v1.5h5.25V8h1.5V4.752H12v-1.5H6.75V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M7.305 5.39L12 8v-.735L8.632 5.39H7.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.305 5.39L12 8v-.735L8.632 5.39H7.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M7.305 5.39L12 8v-.735L8.633 5.39H7.304zm-3.937 0L0 7.265V8l4.695-2.61H3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.695 2.607L0-.003V.74l3.368 1.867h1.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4.695 2.607L0-.003V.74l3.368 1.867h1.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4.695 2.607L0-.003V.74l3.368 1.867h1.327zm3.938 0L12 .74v-.743l-4.695 2.61h1.328z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/Australia.b367f3f1ddac41a48675def10496c58a.svg";
export { ForwardRef as ReactComponent };